import store from '@/store'
import Initials from '@/views/steps/Initials'
import Account from '@/views/steps/Account'
import Poll from '@/views/steps/Poll'
import Deposit from '@/views/steps/Deposit'
import Risk from '@/views/steps/Risk'
import Activation from '@/views/steps/Activation'
import Portfolio from '@/views/steps/Portfolio'
import Init from '@/views/Init'

export default [

  // ------------------------------------------------------------------- [Steps]

  {
    path: '/',
    name: 'initials',
    component: Initials,
    meta: {
      verify: true,
      step: {
        idx: 0
      }
    }
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: {
      verify: true,
      step: {
        idx: 1
      }
    }
  },
  {
    path: '/poll',
    name: 'poll',
    component: Poll,
    meta: {
      verify: true,
      step: {
        idx: 2
      }
    }
  },
  {
    path: '/deposit',
    name: 'deposit',
    component: Deposit,
    meta: {
      verify: true,
      step: {
        idx: 3
      }
    }
  },
  {
    path: '/risk',
    name: 'risk',
    component: Risk,
    meta: {
      verify: true,
      step: {
        idx: 4
      }
    }
  },
  {
    path: '/activation',
    name: 'activation',
    component: Activation,
    meta: {
      verify: true,
      step: {
        idx: 5
      }
    }
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: Portfolio,
    meta: {
      verify: true,
      step: {
        idx: 6
      }
    }
  },

  // -------------------------------------------------------------- [Agreements]

  {
    path: '/user-agreements',
    name: 'user-agreements',
    component: () => import(/* webpackChunkName: "agreements" */ '@/views/agreements/UserAgreements.vue'),
    meta: {
      verify: true,
      step: null
    }
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: () => import(/* webpackChunkName: "agreements" */ '@/views/agreements/TermsOfUse.vue'),
    meta: {
      verify: true,
      step: null
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "agreements" */ '@/views/agreements/PrivacyPolicy.vue'),
    meta: {
      verify: true,
      step: null
    }
  },

  // -------------------------------------------------------------------- [Misc]

  {
    path: '/init',
    name: 'init',
    component: Init,
    meta: {
      verify: false,
      step: null
    },
    beforeEnter: (to, from, next) => {
      if (store.getters['moduleSecurity/isTokenVerified']) {
        next({ name: 'initials' })
      } else {
        next()
      }
    }
  },
  {
    path: '*',
    meta: {
      verify: false,
      step: null
    },
    redirect: { name: 'initials' }
  }

]
